var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAuth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.001,
    viewBox: "0 0 40 40.001",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_60",
    "data-name": "Union 60",
    d: "M18.374,38.829V29.656H0V26.4H18.374V20.456H0V17.2H18.374V11.056H0V7.8H18.374V-1.173H21.63V7.8H40v3.256H21.63V17.2H40v3.256H21.63V26.4H40v3.256H21.63v9.172Z",
    transform: "translate(-0.002 1.173)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAuth);
export default __webpack_public_path__ + "static/media/logo-auth.8ed2b27aeed00ca0657328c14a9cb1c2.svg";
export { ForwardRef as ReactComponent };